"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextHelper = void 0;
var lodash_1 = __importDefault(require("lodash"));
exports.TextHelper = {
    getTextFromArrayProperty: function (text, defaultText, delimiter) {
        defaultText = defaultText || '';
        delimiter = delimiter || ', ';
        if (!text || !text.length) {
            return [defaultText];
        }
        // Todo: this can be a helper function.  Idea from https://stackoverflow.com/a/23619085
        var intersperse = function (arr, sep) { return arr.slice(1).reduce(function (xs, x) { return xs.concat([sep, x]); }, [arr[0]]); };
        return intersperse(text, delimiter);
    },
    getTextFromStringProperty: function (text, defaultText) {
        defaultText = defaultText || '';
        if (!text || text === '') {
            return defaultText;
        }
        return text;
    },
    getCountFromArrayProperty: function (collection, defaultText) {
        defaultText = defaultText || '';
        if (!collection || !collection.length) {
            return defaultText;
        }
        var count = collection.length;
        return count.toString();
    },
    doesTextContainSearchCriteria: function (text, searchText) {
        // Exit early because there is nothing to search on.
        if (text === undefined || text === '' || searchText === undefined || searchText === '') {
            return false;
        }
        var regex = new RegExp('(' + lodash_1.default.escapeRegExp(searchText) + ')', 'ig');
        var splits = text.split(regex);
        // As long as there is more than one item in the splits array, the search text has been found.
        if (splits.length > 1) {
            return true;
        }
        // Otherwise there are no matches.
        return false;
    },
};
exports.default = exports.TextHelper;
